import { Injectable } from '@angular/core';
import {
  DwAction,
  DwActionHandler,
  DwActionResult,
  DwActionType,
  DwMdFormActionState
} from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AppMetaDataItemNames, StudentGamificationSummaryEntity } from '../../../meta-data/app-meta-data.service';
import { AppPermissions } from '../../../meta-data/app-permissions.enum';
import { GamificationRepositoryService } from '../services/gamification-repository.service';

@DwAction({
  keyName: 'gamification-reprocess-student',
  display: 'Reprocess Student',
  actionType: DwActionType.formAction,
  parentItemName: AppMetaDataItemNames.StudentGamificationSummary,
  isGlobal: false,
  defaultButtonConfig: {
    useParentDisplay: false,
    buttonText: 'Reprocess Student',
    iconClass: 'fa fa-sync-alt',
    buttonClass: 'btn btn-warning',
    buttonTitle: 'Rebuilds this student\'s gamification days, streak, weather balance, and achievements.'
  },
  defaultSecurityConfig: {
    requireAuthentication: true,
    useEmulatedPermissions: true,
    permissionMeaning: AppPermissions.lMSSetupAdmin,
    requireCanUpdate: false
  },
  defaultConfirmConfig: {
    showDialogConfig: true,
    showConfirmDialog: true,
    title: 'Reprocess student gamification?',
    message: 'This rebuilds the student\'s gamification history and summary from current learning records.'
  }
})
@Injectable()
export class ReprocessStudentGamificationActionService implements DwActionHandler {
  constructor(private readonly repository: GamificationRepositoryService) {}

  handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
    const summary = actionState.formApi.getFormData<StudentGamificationSummaryEntity>();

    return this.repository.reprocessStudent(summary.StudentId).pipe(
      switchMap(result => actionState.formApi.loadData(true).pipe(map(() => result))),
      map(result => ({
        success: result.ProcessedStudentCount > 0,
        message: result.ProcessedStudentCount > 0
          ? `Student gamification reprocessed in ${result.ElapsedMilliseconds} ms.`
          : 'No student gamification records were processed.'
      }))
    );
  }
}
